/**
 * 予約ステータスのラベルと対応ステータスのボタンで使う色。
 * 同じ行に並ぶ2つの列で色がずれないよう、ここにまとめて既存画面の色コードにそろえる。
 * 黄は宿泊ステータス「予約」、赤は宿泊ステータス「チェックイン」（approved-status-button.tsx）、
 * 灰は予約タブのステータスのラベル（_reservation/list.tsx）と同じ色。
 * 対応ステータスの「完了」は、対応済みの行を目立たせないようモックどおり薄い灰にする
 */
export const RESERVATION_TASK_STATUS_COLORS = {
  yellow: '#F2A40B',
  red: '#F47110',
  gray: '#676767',
  lightGray: '#CCCCCC',
} as const
